import { render } from "./DefaultLayout.vue?vue&type=template&id=3415f8d9&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=3415f8d9&scoped=true&lang=css"

import exportComponent from "/var/www/html/pipit-phase5/Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3415f8d9"]])

export default __exports__